
import { defineComponent, PropType } from 'vue'
import { VulnerabilityOccurrenceReachability } from '~/types/types'
import DPill from '../Base/DPill.vue'

export default defineComponent({
  name: 'ReachabilityPill',
  props: {
    reachability: {
      type: String as PropType<VulnerabilityOccurrenceReachability>,
      required: true
    }
  },
  components: {
    DPill
  },
  computed: {
    label() {
      if (this.reachability === undefined) return 'Unknown'
      return {
        [VulnerabilityOccurrenceReachability.Reachable]: 'Reachable',
        [VulnerabilityOccurrenceReachability.Unreachable]: 'Unreachable',
        [VulnerabilityOccurrenceReachability.Unknown]: 'Unknown'
      }[this.reachability]
    },
    icon(): string {
      if (this.reachability === undefined) return 'map-pin-dash-inside'
      return {
        [VulnerabilityOccurrenceReachability.Reachable]: 'map-pin-check-inside',
        [VulnerabilityOccurrenceReachability.Unreachable]: 'map-pin-cross-inside',
        [VulnerabilityOccurrenceReachability.Unknown]: 'map-pin-dash-inside'
      }[this.reachability]
    },
    color(): string {
      if (this.reachability === undefined) return 'vanilla-100'
      return {
        [VulnerabilityOccurrenceReachability.Reachable]: 'cherry-500',
        [VulnerabilityOccurrenceReachability.Unreachable]: 'honey-500',
        [VulnerabilityOccurrenceReachability.Unknown]: 'vanilla-100'
      }[this.reachability]
    }
  }
})
